import { useMetadata } from '#wa/composables/useMetadata'

export function dessertFortifiedFiltersToUrl(filters) {
  if (
    filters.length === 2 &&
    filters.every(
      (filter) =>
        filter.category === 'categories' &&
        ['sweet-wine', 'fortified'].includes(filter.key),
    )
  ) {
    return `dessert-fortified/`
  }
  return undefined
}

export function dessertFortifiedUrlToFilters({ route }) {
  const metadata = useMetadata()
  if (route.params.category !== 'dessert-fortified' || !metadata.searchFilters)
    return undefined
  return metadata.searchFilters.filter(
    (filter) =>
      filter.category === 'categories' &&
      ['sweet-wine', 'fortified'].includes(filter.key),
  )
}

export function sweetFortifiedUrlToFilters({ route }) {
  const metadata = useMetadata()
  if (route.params.category !== 'sweet-fortified' || !metadata.searchFilters)
    return undefined
  return metadata.searchFilters.filter(
    (filter) =>
      filter.category === 'categories' &&
      ['sweet-wine', 'fortified'].includes(filter.key),
  )
}
